/**
 * 配置说明
 * title: 跳转页面自动设置头部标题
 */
export default [
  {
    name: 'License',
    path: '/license',
    component: () =>
      import(/* webpackChunkName: "License" */ '@/views/license/index'),
    meta: { title: '平台资质' },
  },
  {
    name: 'LicenseDongguan',
    path: '/license/dongguan',
    component: () =>
      import(
        /* webpackChunkName: "LicenseDongguan" */ '@/views/license/dongguan'
      ),
    meta: { title: '平台资质' },
  },
];
